module.exports = __webpack_public_path__ + "img/Tomcat.2c43e34.svg";